import { Logger } from '../../domain/Logger';

export class ConsoleLogger implements Logger {
  debug(message: string, context?: any) {
    if (process.env.NODE_ENV !== 'production') {
      console.debug(`[DEBUG] ${message}`, context);
    }
  }

  info(message: string, context?: any) {
    console.info(`[INFO] ${message}`, context);
  }

  warn(message: string, context?: any) {
    console.warn(`[WARN] ${message}`, context);
  }

  error(message: string, context?: any) {
    console.error(`[ERROR] ${message}`, context);
  }
}
